module.exports = __webpack_public_path__ + "static/media/alarm.8f6703a2.svg";